import CreditsInstallments from "../../components/credits/creditsInstallments";
/**

DetailInstallmentPage

صفحه نمایش جزئیات یک قسط انتخاب شده.

@component

@returns JSX.Element
*/
const CreditsInstallmentPage = () => {
  return (
    <div>
      <CreditsInstallments />
    </div>
  );
};

export default CreditsInstallmentPage;
